import { margin } from "@mui/system";
import "./CSS/itemAsientosPaulet.css";
import React, { useRef, useEffect, useState } from "react";
import ItemAsiento from "./Components/ItemAsiento";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { addDoc, updateDoc } from "firebase/firestore";
import { db } from "./FirebaseConfig/firebase";
import { collection, getDocs, setDoc, doc } from "firebase/firestore";
import { useNavigate, useParams, Link } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { query, where } from "firebase/firestore";
import axios from "axios";
import LinearProgress from "@mui/material/LinearProgress";

const MySwal = withReactContent(Swal);

function LlenarDatosPaulet(props) {
  const {
    listaAsientos,
    id,
    nombre,
    isNew,
    isPago,
    idDocReserva,
    idUpdate,
    setListaAsientos,
    maxAsientos,
    setIsNew,
    setIdDocReserva,
    setIdUpdate,
    cip,
    costo,
    lugar,
    tipoEvento,
  } = props;
  const navigate = useNavigate();

  //const [listaAsientosRegistrados, setListaAsientosRegistrados] =

  const [nombreUsuario, setNombreUsuario] = React.useState("");
  const [apellidoUsuario, setApellidoUsuario] = React.useState("");
  const [pbVisibleBusqueda, setpbVisibleBusqueda] = useState(false);

  const [idUsuario, setIdUsuario] = React.useState("");
  const [correo, setCorreo] = React.useState("");
  const [CIP, setCIP] = React.useState("");

  const [nroSerie, setNroSerie] = React.useState("");
  const [correlativo, setCorrelativo] = React.useState("");
  const [monto, setMonto] = React.useState(costo);

  const [estado, setEstado] = React.useState("Entrada Gratis");
  const [duplicidad, setDuplicidad] = React.useState(false);
  const [pbVisible, setpbVisible] = useState(false);

  const asientosRegistradosList = collection(
    db,
    `EVENTOS/${id}/AsientosRegistrados`
  );
  const validarmonto = (monto, costo, e) => {
    MySwal.fire("", "PAGO REGISTRADO", "success");
    setEstado("PAGADO");
    store(e);
    /*
    if (monto < costo) {
      MySwal.fire(
        "",
        "El monto pagado es menor al costo de las entradas",
        "warning"
      );
    } else {
      if (monto > costo) {
        MySwal.fire(
          "",
          "El monto pagado es superior al costo de las entradas",
          "warning"
        );
      } else {
        MySwal.fire("", "PAGO REGISTRADO", "success");
        setEstado("PAGADO");
        store(e);
      }
    }*/
  };
  const validarFormulario = async (e) => {
    verificarDuplicidad();
    if (nombreUsuario == "" || CIP == "") {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      if (isPago) {
        if (nroSerie == "" || correlativo == "" || monto == "") {
          MySwal.fire("", "Llenar los campos de pago", "warning");
        } else {
          revisarPago(e);
        }
      } else {
        store();
      }
    }
  };
  const revisarPago = async (e) => {
    //console.log("corr " + correlativo + "serie " + nroSerie + "monto " + monto);
    try {
      const res = await axios.get(
        `https://cip-cda-registro-production.up.railway.app/pagos/${correlativo}/${nroSerie}/${monto}`
      );
      /*console.log(
        "data web  " + res.data[0].ncodcli.toString() + "data local " + cip
      );*/
      if (res.data[0].vnumdoc.includes(correlativo)) {
        setCorrelativo(res.data[0].vnumdoc);
        setNroSerie(res.data[0].vserdoc);
        setMonto(res.data[0].nvaltot);

        if (res.data[0].ncodcli != CIP) {
          MySwal.fire(
            "",
            "El boucher no coincide con el Codigo CIP " + CIP,
            "warning"
          );
        } else {
          if (isNew) {
            validarmonto(monto, costo, e);
          } else {
            // ES ACTUALIZACION DE ENTRADAS

            const listaref = collection(
              db,
              `EVENTOS/${id}/AsientosRegistrados/${idDocReserva}/reciboPago`
            );
            const q = query(listaref);
            const documentSnapshot = await getDocs(q);
            var flboucherduplicado = true;
            if (documentSnapshot.size > 0) {
              //console.log("OTROS BOUCHERS ENCONTRADOS");
              var sumatotal = 0;
              documentSnapshot.forEach((doc) => {
                if (
                  (correlativo.includes(doc.data().correlativo) ||
                    doc.data().correlativo.includes(correlativo)) &&
                  (nroSerie.includes(doc.data().nroSerie) ||
                    doc.data().nroSerie.includes(nroSerie)) &&
                  monto == doc.data().monto
                ) {
                  //console.log("BOUCHER DUCPLICADO");
                  flboucherduplicado = false;
                  MySwal.fire(
                    "",
                    "ESTE RECIBO YA FUE USADO ANTERIORMENTE",
                    "warning"
                  );
                } else {
                  sumatotal = sumatotal + parseInt(doc.data().monto);
                }
              });
              if (flboucherduplicado) {
                sumatotal = sumatotal + parseInt(monto);

                validarmonto(sumatotal, costo, e);
              }
            } else {
              //console.log("NO HAY OTROS BOUCHERS");
              validarmonto(monto, costo, e);
            }
          }
        }
      } else {
        MySwal.fire("", "DATOS DE PAGO INCORRECTO", "warning");
      }
    } catch (err) {
      MySwal.fire("", "DATOS DE PAGO INCORRECTO", "warning");
    }
  };
  var duplicidadprueba = false;
  const verificarDuplicidad = async () => {
    const listaref = collection(db, `EVENTOS/${id}/AsientosRegistrados`);
    const q = query(listaref);
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (doc) => {
      listaAsientos.forEach(async (asi) => {
        if (doc.data().CIP != localStorage.getItem("idLocal")) {
          if (doc.data().asientos.split(",").includes(asi)) {
            setDuplicidad(true);
            duplicidadprueba = true;
            Swal.fire({
              text: "Hay asientos que ya fueron registrados. Por favor intente nuevamente",
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Esta bien",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        } else {
          console.log(
            "asientos mximos" +
              maxAsientos +
              " suma " +
              (doc.data().asientos.split(",").length + listaAsientos.length)
          );
          if (
            doc.data().asientos.split(",").length + listaAsientos.length >
            maxAsientos
          ) {
            Swal.fire({
              icon: "warning",
              title: "Oops...",
              text:
                "Se ha reservado previamente " +
                doc.data().asientos.split(",").length +
                " asientos: " +
                doc.data().asientos +
                " el limite maximo es " +
                maxAsientos +
                " asientos",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Esta bien",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
				
              }
            });
          }
        }
      });
    });
    if (duplicidadprueba) {
      store();
    } else {
    }
  };
  function timeout(number) {
    return new Promise((res) => setTimeout(res, number));
  }
  function getRandomInt(min, max) {
    return Math.random() * (max - min) + min;
  }
  //console.log("Nuermo randon " + parseInt(getRandomInt(1, 7)) * 1000);

  const store = async () => {
    var idDocumento = "";
    //console.log("duplicidad " + duplicidadprueba);
    MySwal.fire({
      title:
        "Reservar Asiento(s)  " + listaAsientos.toString() + "? " + idDocumento,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Reservar",
    }).then(async (result) => {
      setpbVisible(true);

      var randon = parseInt(getRandomInt(1, 10)) * 250;

      await timeout(randon); //for 1 sec delay

      verificarDuplicidad();

      if (result.isConfirmed) {
        //console.log("duplicidad pruebas sdfsdgdf gh " + duplicidadprueba);

        const listaref = collection(db, `EVENTOS/${id}/AsientosRegistrados`);
        const q = query(listaref);
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach(async (doc) => {
          listaAsientos.forEach(async (asi) => {
            if (doc.data().CIP != localStorage.getItem("idLocal")) {
              if (doc.data().asientos.split(",").includes(asi)) {
                setDuplicidad(true);
                duplicidadprueba = true;
                Swal.fire({
                  text: "Hay asientos que ya fueron registrados. Por favor intente nuevamente",
                  icon: "error",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Esta bien",
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.location.reload();
                  }
                });
              }
            }
          });
        });
        //console.log("duplicidad pruebas primera parte  " + duplicidadprueba);
        if (duplicidadprueba) {
          Swal.fire({
            text: "Hay asientos que ya fueron registrados. Por favor intente nuevamente",
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Esta bien",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        } else {
          if (isNew) {
            //console.log("AGREGAR NUEVO : ID USUARIO" + idUsuario);
            if (lugar == "Salon de eventos") {
              await addDoc(asientosRegistradosList, {
                CIP: CIP,
                asientos: listaAsientos.toString(),
                estado: estado,
                nombre: nombreUsuario,
                apellidos: apellidoUsuario,

                fecha: new Date()
                  .toLocaleString("es-ES", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                  })
                  .toString(),
              }).then(async (docRef) => {
                //console.log("ENTRADA NUEVA AGREGADA EN EVENTO");
                idDocumento = docRef.id;
                if (isPago) {
                  const reciboPago = collection(
                    db,
                    `EVENTOS/${id}/AsientosRegistrados/${docRef.id}/reciboPago`
                  );
                  await addDoc(reciboPago, {
                    correlativo: correlativo,
                    monto: monto,
                    nroSerie: nroSerie,
                  });
                }
                //console.log("el id del doc es creado es " + idDocumento);
                // Aquí puedes hacer lo que necesites con el ID del documento
              });
            }
            if (lugar == "Auditorio Paulet") {
              await addDoc(asientosRegistradosList, {
                CIP: CIP,
                asientos: listaAsientos.toString(),
                estado: estado,
                nombre: nombreUsuario,
                apellidos: apellidoUsuario,

                fecha: new Date()
                  .toLocaleString("es-ES", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                  })
                  .toString(),
              }).then(async (docRef) => {
                //console.log("ENTRADA NUEVA AGREGADA EN EVENTO");
                idDocumento = docRef.id;
                if (isPago) {
                  const reciboPago = collection(
                    db,
                    `EVENTOS/${id}/AsientosRegistrados/${docRef.id}/reciboPago`
                  );
                  await addDoc(reciboPago, {
                    correlativo: correlativo,
                    monto: monto,
                    nroSerie: nroSerie,
                  });
                }
                //console.log("el id del doc es creado es " + idDocumento);
                // Aquí puedes hacer lo que necesites con el ID del documento
              });
            }
            if (lugar == "Salon de eventos") {
              await addDoc(
                collection(
                  db,
                  `USUARIOS/${
                    idUsuario ? idUsuario : localStorage.getItem("idDocumento")
                  }/AsientosRegistrados`
                ),
                {
                  asientos: listaAsientos.toString(),
                  estado: estado,
                  evento: nombre,
                  apellidos: apellidoUsuario,
                  idEvento: id,
                  idEntrada: idDocumento,

                  fecha: new Date()
                    .toLocaleString("es-ES", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                    })
                    .toString(),
                }
              ).then(async (docRef) => {
                //console.log("ENTRADA NUEVA AGREGADA EN USUARIO");
              });
            }
            if (lugar == "Auditorio Paulet") {
              await addDoc(
                collection(
                  db,
                  `USUARIOS/${
                    idUsuario ? idUsuario : localStorage.getItem("idDocumento")
                  }/AsientosRegistrados`
                ),
                {
                  asientos: listaAsientos.toString(),
                  estado: estado,
                  evento: nombre,
                  apellidos: apellidoUsuario,
                  idEvento: id,
                  idEntrada: idDocumento,
                  fecha: new Date()
                    .toLocaleString("es-ES", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                    })
                    .toString(),
                }
              ).then(async (docRef) => {
                //console.log("ENTRADA NUEVA AGREGADA EN USUARIO");
              });
            }
          } else {
            //console.log("ENTRADA EDITADA EN EVENTO");
            var evento = doc(
              db,
              `EVENTOS/${id}/AsientosRegistrados`,
              idDocReserva
            );
            const data = {
              asientos: listaAsientos.toString(),
              estado: isPago ? "Pagado" : "Entrada Gratis",

              fecha: new Date()
                .toLocaleString("es-ES", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                })
                .toString(),
            };
            await updateDoc(evento, data).then(async () => {
              if (isPago) {
                const reciboPago = collection(
                  db,
                  `EVENTOS/${id}/AsientosRegistrados/${idDocReserva}/reciboPago`
                );
                await addDoc(reciboPago, {
                  correlativo: correlativo,
                  monto: monto,
                  nroSerie: nroSerie,
                });
              }
            });

            //console.log("ENTRADA EDITADA EN USUARIO");
            evento = doc(
              db,
              `USUARIOS/${
                idUsuario ? idUsuario : localStorage.getItem("idDocumento")
              }/AsientosRegistrados`,
              idUpdate
            );
            await updateDoc(evento, data);
            //console.log("EVENTO EDITADO EN USUARIO");
            idDocumento = idDocReserva;
            //console.log("el id del doc es actualizado es " + idDocReserva);
          }

          Swal.fire("Registro exitoso ", "", "success");
          setpbVisible(false);

          if (localStorage.getItem("nombreLocal") != "CIP") {
            navigate(
              `/eventos/${props.id}/registrarParticipante/${idDocumento}`
            );
          } else {
            navigate(`/panelCDA/eventos`);
          }
        }

        if (duplicidad) {
          Swal.fire({
            text: "Hay asientos que ya fueron registrados. Por favor intente nuevamente",
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Esta bien",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        } else {
        }
      }
    });
  };

  const buscarCodigoCip = async () => {
    setpbVisibleBusqueda(true);
    let usuarioEncontrado = false;

    console.log("Buscar codigo " + CIP);
    const q = query(collection(db, "USUARIOS"), where("cip", "==", CIP));
    const querySnapshot = await getDocs(q);
    console.log(querySnapshot.length);

    querySnapshot.forEach((doc) => {
      usuarioEncontrado = true;
      console.log("ENCONTRO AL USER EN FIREBASE");
      console.log(doc.id);

      setIdUsuario(doc.id);
      //buscarIdAsientoUser();
      setNombreUsuario(doc.data().nombre);
      setApellidoUsuario(doc.data().apellidos);
      setpbVisibleBusqueda(false);
    });
    if (usuarioEncontrado == false) {
      console.log(
        "NO ENCONTRO AL USUARIO EN FIREBASE , PROCEDE A BUSCARLO EN MYSQL  "
      );
      const res = await axios.get(
        `https://cip-cda-registro-production.up.railway.app/colegiados/${CIP}`
      );
      console.log(res.data.length != 0);
      if (res.data.length != 0) {
        console.log(
          "USUARIO ENCONTRADO EN SQL,PROCEDE A CREAR USUARIO EN FIREBASE"
        );
        const dbusuario = collection(db, `USUARIOS`);
        await addDoc(dbusuario, {
          apellidos: res.data[0].vapecol,
          nombre: res.data[0].vnomcol,
          cip: res.data[0].ncodcol.toString(),
          dni: res.data[0].ndnicol,
          nivel: "ingeniero",
        }).then(async (docRef) => {
          console.log(docRef.id);
          setIdUsuario(docRef.id);
          //buscarIdAsientoUser();
          setNombreUsuario(res.data[0].vnomcol);
          setApellidoUsuario(res.data[0].vapecol);
          setpbVisibleBusqueda(false);
        });
      } else {
        setpbVisibleBusqueda(false);
        MySwal.fire("", "CIP NO ENCONTRADO", "error");
      }
    }
  };
  const buscarAsientosPorCIP = async () => {
    //console.log("Buscar asientos por cip " + id);
    const q = query(
      collection(db, `EVENTOS/${id}/AsientosRegistrados`),
      where("CIP", "==", CIP)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      setIdDocReserva(doc.id);

      if (
        doc.data().asientos.split(",").length + listaAsientos.length >
        maxAsientos
      ) {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text:
            "Se ha reservado previamente " +
            doc.data().asientos.split(",").length +
            " asientos: " +
            doc.data().asientos +
            " el limite maximo es " +
            maxAsientos +
            " asientos",
        });
        setCIP("");
        setApellidoUsuario("");
        setNombreUsuario("");
      } else {
        setIsNew(false);
        setListaAsientos(doc.data().asientos.split(",").concat(listaAsientos));
      }
    });
  };
  const buscarIdAsientoUser = async () => {
    //console.log("Buscar asientos por cip " + id);
    const q = query(
      collection(db, `USUARIOS/${idUsuario}/AsientosRegistrados`),
      where("idEvento", "==", id)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      setIdUpdate(doc.id);
      setIdDocReserva(doc.data().idEntrada);

      if (
        doc.data().asientos.split(",").length + listaAsientos.length >
        maxAsientos
      ) {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text:
            "Se ha reservado previamente " +
            doc.data().asientos.split(",").length +
            " asientos: " +
            doc.data().asientos +
            " el limite maximo es " +
            maxAsientos +
            " asientos",
        });
        setCIP("");
        setApellidoUsuario("");
        setNombreUsuario("");
      } else {
        setIsNew(false);
        doc.data().asientos.split(",").concat(listaAsientos);
      }
    });
  };
  useEffect(() => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      setCIP(localStorage.getItem("idLocal"));
      setNombreUsuario(localStorage.getItem("nombreLocal"));
      setApellidoUsuario(localStorage.getItem("apellidoLocal"));
      if (lugar == "Salon de eventos") {
        setNroSerie(
          JSON.parse(localStorage.getItem("detallesRecibo")).nroSerie
        );
        setMonto(JSON.parse(localStorage.getItem("detallesRecibo")).monto);
        setCorrelativo(
          JSON.parse(localStorage.getItem("detallesRecibo")).correlativo
        );
      }
    }
    if (localStorage.getItem("nombreLocal") == "CIP") {
      setCIP(localStorage.getItem("idLocal"));
      setNombreUsuario(localStorage.getItem("nombreLocal"));
    }
    if (isPago) {
      setEstado("Pagado");
    }
  }, []);
  useEffect(() => {
    //console.log("VAMOS A CER SI ENTRA");
    buscarIdAsientoUser();
  }, [idUsuario]);
  useEffect(() => {
    if (duplicidad) {
      Swal.fire({
        text: "Hay asientos que ya fueron registrados. Por favor intente nuevamente",
        icon: "error",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Esta bien",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
    buscarIdAsientoUser();
  }, [duplicidad]);
  const containerStyle = {
    display: "grid",
    gridTemplateRows: "auto 1fr",
    gap: "10px",
    width: "300px",
    marginTop: "30px",
  };

  const elementStyle = {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: "10px",
  };

  const inputStyle = {
    width: "100%",
  };
  return (
    <div className="item-panel">
      <div>
        <div className="ld-titulo">Datos del asistente</div>
        <div style={containerStyle}>
          <div style={elementStyle}>
            <TextField
              style={inputStyle}
              id="outlined-basic"
              label="Codigo CIP"
              value={CIP}
              variant="standard"
              disabled={
                localStorage.getItem("nivelUsuario") == "ingeniero"
                  ? true
                  : false
              }
              onChange={(e) => setCIP(e.target.value)}
            />
            <img
              src={require(`./img/buscar.png`)}
              type="submit"
              alt="salir"
              style={{
                cursor: "pointer",
                width: "40px",
                visibility:
                  localStorage.getItem("nivelUsuario") == "ingeniero"
                    ? "hidden"
                    : "visible",
              }}
              onClick={() => buscarCodigoCip()}
            />
          </div>
          <TextField
            style={inputStyle}
            value={nombreUsuario + " " + apellidoUsuario}
            id="outlined-basic"
            label="Nombre y apellido"
            variant="standard"
            disabled="true"
          />
        </div>

        <div style={containerStyle}>
          {pbVisibleBusqueda ? (
            <LinearProgress
              color="success"
              style={{ marginBottom: 20, textAlign: "center" }}
            />
          ) : null}
          {isPago ? (
            <div>
              <div className="ld-titulo">Datos del pago</div>
              <TextField
                style={inputStyle}
                value={nroSerie}
                id="outlined-basic"
                label="Nro de Serie"
                variant="standard"
                type="number"
                onChange={(e) => setNroSerie(e.target.value)}
              />
              <TextField
                style={inputStyle}
                value={correlativo}
                id="outlined-basic"
                label="Correlativo"
                variant="standard"
                type="number"
                onChange={(e) => setCorrelativo(e.target.value)}
              />
              <TextField
                style={inputStyle}
                value={monto}
                id="outlined-basic"
                label="Monto"
                variant="standard"
                type="number"
                onChange={(e) => setMonto(e.target.value)}
              />
            </div>
          ) : null}
        </div>
        <div className="btnInferior">
          {pbVisible ? (
            <LinearProgress color="success" style={{ marginBottom: 20 }} />
          ) : null}
          <input
            type="submit"
            value="Reservar"
            className="btnAbajo"
            onClick={validarFormulario}
          />
        </div>
      </div>
    </div>
  );
}

export default LlenarDatosPaulet;
